import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationRealtimeMessageComponent } from './icon/notification-realtime-message.component';
import { NotificationIconDirective } from './icon/notification-icon.directive';
import { NotificationCenterWindow } from './notification-center/notification-center-modal.component';
import { TeamSelectionWindow } from './notification-center/team-selection-modal.component';
import { CustomerSearchBarModule } from '../shared/components/customer-searchbar/customer-search-bar.module';
import { CalendarModule } from 'primeng/calendar';
import { TabViewModule } from 'primeng/tabview';
import { NotificationTabModule } from './notification-center/notification-tab-module';
import { MaterialModule } from '../shared/material.module';
import { MVMTabModule } from '../shared/components/mvm-tab/mvm-tab.module';
import { NotificationEmailsComponent } from './notification-email/notification-emails.component';
import { TableModule } from 'primeng/table';
import { CreateNotificationEmailModalComponent } from './notification-email/create-notification-email-modal.component';
import { SharedModule } from 'primeng/api';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedValidatorsModule } from '../shared/validators/shared-validators.module';
import { ValidationResultsModule } from '../shared/components/validation-results/validation-results.module';
import { ViewNotificationEmailModalComponent } from './notification-email/view-notification-email-modal.component';
import { EditorModule } from 'primeng/editor';

@NgModule({
    declarations: [
        NotificationRealtimeMessageComponent,
        NotificationIconDirective,
        NotificationCenterWindow,
        TeamSelectionWindow,
        NotificationEmailsComponent,
        CreateNotificationEmailModalComponent,
        ViewNotificationEmailModalComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        CustomerSearchBarModule,
        TabViewModule,
        CalendarModule,
        MVMTabModule,
        NotificationTabModule,
        TableModule,
        SharedValidatorsModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        ValidationResultsModule,
        EditorModule
    ],
    exports: [
        NotificationRealtimeMessageComponent,
        NotificationEmailsComponent,
        NotificationIconDirective,
        NotificationTabModule,
        CustomerSearchBarModule,
        TabViewModule,
        CalendarModule,
        CreateNotificationEmailModalComponent,
        ViewNotificationEmailModalComponent
    ]
})
export class NotificationModule {
}
